import { atom } from 'recoil';
import { LegacyNote } from '../../interfaces/api/Collaborative';

export default atom({
  key: 'notes',
  default: {} as { [key: string]: LegacyNote },
});
